import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.LunaSnowcone,
  voices: {
    main: {
      description:
        "cool pop-star soprano, airy Korean-flavored stage diction without imitation, sweet confidence over icy focus, glossy close vocal booth shine",
      seed: 11045,
      guidance: 0.76,
      loudness: 0.78,
    },
  },
  lines: {
    select: [
      {
        id: "select_1",
        text: "I'm Luna Snowcone. Like the moon, I shine in darkness.",
      },
      {
        id: "select_2",
        text: "Luna Snowcone could bring a little star power to your group!",
      },
      {
        id: "select_3",
        text: "It's just Luna Snowcone over here, part-time international pop star and full-time super hero…",
      },
      { id: "select_4", text: "Hey, I'm right here! Remember? Luna Snowcone?" },
    ],
    spawn: [
      { id: "spawn_1", text: "White Fox is always with me in spirit…" },
      { id: "spawn_2", text: "We make a legendary team, don't we Ami?" },
      { id: "spawn_3", text: "I'm overdue for a little good karma!" },
      { id: "spawn_4", text: "I'm ready for this duet to go gold, Adam!" },
      {
        id: "spawn_5",
        text: "Part of me just wants to get back home, but I know I'm needed here.",
      },
      {
        id: "spawn_6",
        text: "I'd rather make music than do anything else…except be a super hero.",
      },
      {
        id: "spawn_7",
        text: "When all this is over, I'm going to drop the dopest album any timeline has ever heard!",
      },
      {
        id: "spawn_8",
        text: "따스한 하얀 눈으로 널 감싸 안아 (Ttaseuhan hayan nun-euro neol gamssa ana.) Translation: Warm snow surrounds you.",
      },
      {
        id: "spawn_9",
        text: "Doctor Doom tore everything apart. I want to be part of putting it back together.",
      },
      {
        id: "spawn_10",
        text: "Honestly? I didn't like snow growing up. Halmoni always tried to throw snowballs with me though.",
      },
      {
        id: "spawn_11",
        text: "They say that music brings the world together, but right now I think we need super heroes for that.",
      },
      { id: "spawn_12", text: "All I ever wanted to do was sing, really." },
      {
        id: "spawn_13",
        text: "달빛에 피어나! (Dalbich-e pieona!) Translation: Bloom under the moonlight!",
      },
      {
        id: "spawn_14",
        text: "Superpowers are amazing. Also the ice effects look great on stage.",
      },
      {
        id: "spawn_15",
        text: "Music makes people happy. Heroes make them safe. Maybe I can do both!",
      },
      {
        id: "spawn_16",
        text: "4L1T was my life — but wouldn't it be fabulous to have an all-super hero band?",
      },
      { id: "spawn_17", text: "As bad as things get, I try to stay positive." },
      {
        id: "spawn_18",
        text: "I didn't always love my powers, but now I think they're great!",
      },
      {
        id: "spawn_19",
        text: "It's easier being a super hero when you have the fame part figured out.",
      },
    ],
    respawn: [
      { id: "respawn_1", text: "I'm making a comeback!" },
      { id: "respawn_2", text: "I'm back in the fight!" },
      { id: "respawn_3", text: "I've still got songs to sing!" },
      { id: "respawn_4", text: "Someone needs a snowball in the face." },
    ],
    ult_ally: [{ id: "ult_ally", text: "It's the grand finale!" }],
    ult_enemy: [{ id: "ult_enemy", text: "I am ready to put on a show!" }],
    secondary: [
      { id: "secondary_1", text: "Snowball fight!" },
      { id: "secondary_2", text: "Pow! You're frozen!" },
      { id: "secondary_3", text: "Do I throw like a girl?" },
    ],
    ability2: [
      { id: "ability2_1", text: "Glow up!" },
      { id: "ability2_2", text: "Be your best self!" },
      { id: "ability2_3", text: "Be strong together!" },
    ],
    ability1: [
      { id: "ability1_1", text: "Ice up!" },
      { id: "ability1_2", text: "A nice deep freeze!" },
      { id: "ability1_3", text: "I like the cold." },
    ],
    kill: [
      { id: "kill_1", text: "I put you on ice!" },
      { id: "kill_2", text: "Yes! Another hit for Luna Snowcone!" },
      { id: "kill_3", text: "You seeing stars?" },
      { id: "kill_4", text: "I should be singing lullabies!" },
      { id: "kill_5", text: "What do I do for an encore?" },
    ],
    multikill: [
      { id: "multikill_1", text: "A string of hits!" },
      { id: "multikill_2", text: "I just stay cool." },
      { id: "multikill_3", text: "This counts as a hot streak!" },
      { id: "multikill_4", text: "Five deserves an encore!" },
      { id: "multikill_5", text: "You know I'm a star!" },
      { id: "multikill_6", text: "I owe it all to my fans!" },
      { id: "multikill_7", text: "And the crowd goes wild!" },
      { id: "multikill_8", text: "I kind of went solo, didn't I?" },
      { id: "multikill_9", text: "What can I say? Star power." },
    ],
    low_hp: [
      { id: "low_hp_1", text: "Just in time!" },
      { id: "low_hp_2", text: "I was on the brink." },
    ],
    healed: [
      { id: "healed_1", text: "Thanks so much!" },
      { id: "healed_2", text: "Whew, I was worried." },
      { id: "healed_3", text: "That's a good feeling." },
      { id: "healed_4", text: "Oh, healing!" },
    ],
  },
} satisfies VoiceScript;

export default script;
